module.exports = __webpack_public_path__ + "static/media/logo-visa.87ef567b.svg";